var _circle, _ellipse, _path, _ellipse2, _path2, _ellipse3, _path3, _ellipse4, _path4, _ellipse5, _path5, _ellipse6, _path6, _ellipse7, _path7, _ellipse8, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound84AError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 31,
  r: 14,
  fill: "#464D57"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 31,
  cy: 9,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(90 31 9)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#f39898",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M25 10V9c0-2.761 2.686-5 6-5s6 2.239 6 5v1"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 31,
  cy: 53,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(-90 31 53)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#f39898",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M37 52v1c0 2.761-2.686 5-6 5s-6-2.239-6-5v-1"
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 15.444,
  cy: 46.556,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(-45 15.444 46.556)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#f39898",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m20.393 50.092-.707.707c-1.952 1.953-5.435 1.636-7.778-.707s-2.66-5.826-.707-7.778l.707-.707"
})), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 46.556,
  cy: 15.444,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(135 46.556 15.444)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#f39898",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m41.607 11.908.707-.707c1.952-1.952 5.435-1.636 7.778.707s2.66 5.826.707 7.778l-.707.707"
})), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 9,
  cy: 31,
  fill: "#464D57",
  rx: 5,
  ry: 6
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#f39898",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M10 37H9c-2.761 0-5-2.686-5-6s2.239-6 5-6h1"
})), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 53,
  cy: 31,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(-180 53 31)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#f39898",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M52 25h1c2.761 0 5 2.686 5 6s-2.239 6-5 6h-1"
})), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 15.444,
  cy: 15.444,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(45 15.444 15.444)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#f39898",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m11.908 20.393-.707-.707c-1.952-1.952-1.636-5.435.707-7.778s5.826-2.66 7.778-.707l.707.707"
})), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 46.556,
  cy: 46.556,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(-135 46.556 46.556)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#f39898",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m50.092 41.607.707.707c1.953 1.952 1.636 5.435-.707 7.778s-5.826 2.66-7.778.707l-.707-.707"
})));
SvgRound84AError.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound84AError);
export default ForwardRef;